export default "__VITE_ASSET__c646783c__"